import { defineComponent, provide, reactive, h } from '@nuxtjs/composition-api';
import { isMatch, cloneDeep } from 'lodash';
import OModalBase from './OModalBase';

export const ModalContextSymbol = Symbol('ModalContextSymbol');

const defaultConfig = {
  modalContainerClass: 'modals',
  modalClass: 'modal',
};

export const ModalProvider = defineComponent({
  setup(props, { slots }) {
    const configuration = defaultConfig;
    const state = reactive({
      modalEntries: [],
      addModal,
      removeModal,
    });

    function getModalIndex(modalEntry) {
      return state.modalEntries.findIndex((localModalEntry) => isMatch(localModalEntry, modalEntry));
    }

    function addModal(modalEntry) {
      const modalIndex = getModalIndex(modalEntry);
      if (modalIndex !== -1) {
        // console.warn('tried to open a modal that was already opened');
      } else {
        state.modalEntries.push(modalEntry);
      }
    }

    function removeModal(modalEntry) {
      const modalIndex = getModalIndex(modalEntry);
      if (modalIndex !== -1) {
        const newModals = [...state.modalEntries];
        newModals.splice(modalIndex, 1);
        state.modalEntries = newModals;
      } else {
        // console.warn(`tried to close a modal that isn't open`);
      }
    }

    // provide state
    provide(ModalContextSymbol, state);

    return () => {
      const modalEntries =
        state.modalEntries.length > 0 &&
        h(
          'div',
          { class: configuration.modalContainerClass },
          state.modalEntries.map((modalEntry, i) => {
            return h(
              OModalBase,
              {
                key: `modal-${i}`,
                // attrs bind
                attrs: {
                  class: configuration.modalClass,
                  'aria-label': modalEntry.label,
                  role: modalEntry.role,
                },
              },
              [h(modalEntry.modal, { props: reactive(cloneDeep(modalEntry.props)) }, [])]
            );
          })
        );
      return h('div', [slots.default(), modalEntries]);
    };
  },
});
